import { render, staticRenderFns } from "./BankAccountSection.vue?vue&type=template&id=6b4cce06"
import script from "./BankAccountSection.vue?vue&type=script&lang=js"
export * from "./BankAccountSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports